import {createRouter, createWebHistory} from 'vue-router';
import Swal from "sweetalert2";


import SplashPage from "@/components/SplashPage.vue";
import AccessPage from "@/components/AccessPage.vue";
import LoginPage from "@/components/LoginPage.vue";
import OtpPage from "@/components/OtpPage.vue";
import RegisterPage from "@/components/RegisterPage.vue";
import HomePage from "@/components/HomePage.vue";
import CategoryWorker from "@/components/CategoryWorker.vue";
import DetailsWorker from "@/components/DetailsWorker.vue";
import MyCars from "@/components/MyCars.vue";
import EmergencyNumbers from "@/components/EmergencyNumbers.vue";
import CategoryAddAdvertising from "@/components/CategoryAddAdvertising.vue";
import AddAdvertising from "@/components/AddAdvertising.vue";
import CategoryAdvertising from "@/components/CategoryAdvertising.vue";
import AdvertisingPage from "@/components/AdvertisingPage.vue";
import DetailsAdvertising from "@/components/DetailsAdvertising.vue";
import CarService from "@/components/CarService.vue";
import ServiceRegistration from "@/components/ServiceRegistration.vue";
import ProfilePage from "@/components/ProfilePage.vue";
import MyAdvertising from "@/components/MyAdvertising.vue";
import BillOfLadingPage from "@/components/BillOfLadingPage.vue";
import AddBillOfLading from "@/components/AddBillOfLading.vue";
import AddCarExpenses from "@/components/AddCarExpenses.vue";
import PrivacyPage from "@/components/PrivacyPage.vue";
import MyProfile from "@/components/MyProfile.vue";
import MarksPage from "@/components/MarksPage.vue";
import ProfileChats from "@/components/ProfileChats.vue";
import ChatsPage from "@/components/ChatsPage.vue";

import W_SignUp from "@/components/W_SignUp.vue";
import W_HomePage from "@/components/W_HomePage.vue";
import W_MyCustomer from "@/components/W_MyCustomer.vue";
import W_ServicesPerformed from "@/components/W_ServicesPerformed.vue";
import W_SignUpService from "@/components/W_SignUpService.vue";
import W_ProfileWorker from "@/components/W_ProfileWorker.vue";
import QuestionsPage from "@/components/QuestionsPage.vue";
import W_ProfileEdit from "@/components/W_ProfileEdit.vue";
import W_PreviewChats from "@/components/W_PreviewChats.vue";
import W_ChatsWorker from "@/components/W_ChatsWorker.vue";
import W_ReportingService from "@/components/W_ReportingService.vue";
import SearchBy from "@/components/SearchBy.vue";
import MyTickets from "@/components/MyTickets.vue";
import TicketsPage from "@/components/TicketsPage.vue";


const routes = [
    { path: '/', name: 'SplashPage', component: SplashPage },
    { path: '/AccessPage', name: 'AccessPage', component: AccessPage },
    { path: '/LoginPage', name: 'LoginPage', component: LoginPage },
    { path: '/OtpPage/:phone/', name: 'OtpPage', component: OtpPage },
    { path: '/RegisterPage/:phone', name: 'RegisterPage', component: RegisterPage },
    { path: '/HomePage', name: 'HomePage', component: HomePage },
    { path: '/CategoryWorker/:type', name: 'CategoryWorker', component: CategoryWorker },
    { path: '/DetailsWorker/:id', name: 'DetailsWorker', component: DetailsWorker },
    { path: '/MyCars', name: 'MyCars', component: MyCars },
    { path: '/EmergencyNumbers', name: 'EmergencyNumbers', component: EmergencyNumbers },
    { path: '/CategoryAddAdvertising', name: 'CategoryAddAdvertising', component: CategoryAddAdvertising },
    { path: '/AddAdvertising/:action', name: 'AddAdvertising', component: AddAdvertising },
    { path: '/CategoryAdvertising', name: 'CategoryAdvertising', component: CategoryAdvertising },
    { path: '/AdvertisingPage/:cat_id', name: 'AdvertisingPage', component: AdvertisingPage },
    { path: '/DetailsAdvertising', name: 'DetailsAdvertising', component: DetailsAdvertising },
    { path: '/CarService/:action', name: 'CarService', component: CarService },
    { path: '/ServiceRegistration/:action/:service_id', name: 'ServiceRegistration', component: ServiceRegistration },
    { path: '/ProfilePage', name: 'ProfilePage', component: ProfilePage },
    { path: '/MyAdvertising', name: 'MyAdvertising', component: MyAdvertising },
    { path: '/BillOfLadingPage', name: 'BillOfLadingPage', component: BillOfLadingPage },
    { path: '/AddBillOfLading/:action/:type', name: 'AddBillOfLading', component: AddBillOfLading },
    { path: '/AddCarExpenses/:action/:exp_id', name: 'AddCarExpenses', component: AddCarExpenses },
    { path: '/PrivacyPage/:action', name: 'PrivacyPage', component: PrivacyPage },
    { path: '/QuestionsPage', name: 'QuestionsPage', component: QuestionsPage },
    { path: '/MyProfile', name: 'MyProfile', component: MyProfile },
    { path: '/MarksPage', name: 'MarksPage', component: MarksPage },
    { path: '/ProfileChats', name: 'ProfileChats', component: ProfileChats },
    { path: '/ChatsPage/:type', name: 'ChatsPage', component: ChatsPage },
    { path: '/SearchBy/:word', name: 'SearchBy', component: SearchBy},

    { path: '/MyTickets', name: 'MyTickets', component: MyTickets},
    { path: '/Tickets', name: 'TicketsPage', component: TicketsPage},

    { path: '/W_SignUp/:phone', name: 'W_SignUp', component: W_SignUp },
    { path: '/W_HomePage', name: 'W_HomePage', component: W_HomePage },
    { path: '/W_MyCustomer', name: 'W_MyCustomer', component: W_MyCustomer },
    { path: '/W_ServicesPerformed/:service_id', name: 'W_ServicesPerformed', component: W_ServicesPerformed },
    { path: '/W_SignUpService/:action/:service_id/:customer_id', name: 'W_SignUpService', component: W_SignUpService },
    { path: '/W_ProfileWorker', name: 'W_ProfileWorker', component: W_ProfileWorker },
    { path: '/W_ProfileEdit', name: 'W_ProfileEdit', component: W_ProfileEdit },
    { path: '/W_PreviewChats', name: 'W_PreviewChats', component: W_PreviewChats },
    { path: '/W_ChatsWorker/:chat_id', name: 'W_ChatsWorker', component: W_ChatsWorker },
    { path: '/W_ReportingService', name: 'W_ReportingService', component: W_ReportingService },
]


const router = createRouter({
    history: createWebHistory(),
    routes
})

let user_id = localStorage.getItem('uid')

router.beforeEach((to, from, next) => {
    Swal.close()
    if (!user_id && to.name !== 'LoginPage' && to.name !== 'OtpPage' && to.name !== 'RegisterPage' && to.name !== 'SplashPage' && to.name !== 'AccessPage' && to.name !== 'W_SignUp' && to.name !== 'PrivacyPage' ) {
        next({ name: 'SplashPage' })
    } else {
        next()
    }
})



export default router;